// React and Hooks
import React, { useCallback, useEffect, useRef, useState } from "react";

// Date-related
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";

// Styles and CSS
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import "./AgencyPolygonCreation.css";
import Control from "react-leaflet-custom-control";
// MUI and Icons
import { GoLocation, GoDeviceCameraVideo } from "react-icons/go";
import { MdOutlineKeyboardDoubleArrowUp } from "react-icons/md";
import { MdDoubleArrow } from "react-icons/md";
import { IoCloseOutline } from "react-icons/io5";
import { FaCircle } from "react-icons/fa";
// Bootstrap
import Modal from "react-bootstrap/Modal";

// Leaflet and Map-related
import L, { point } from "leaflet";
import {
  MapContainer,
  TileLayer,
  FeatureGroup,
  Polygon,
  GeoJSON,
  useMapEvent,
  LayersControl,
  AttributionControl,
  useMapEvents,
} from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import * as turf from "@turf/turf";
import toGeoJSON from "@mapbox/togeojson";
// Utilities and Services
import axios from "axios";
import JSZip, { file } from "jszip";
import AuthService from "../../services/auth.service";
import AuthServiceV2 from "../../services/auth.serviceV2";
import Agencyservice from "../../services/agency.service";
import { cleanDigitSectionValue } from "@mui/x-date-pickers/internals/hooks/useField/useField.utils";
import {
  Button,
  Form,
  Offcanvas,
  Overlay,
  OverlayTrigger,
  Row,
  Tab,
  Tabs,
  Tooltip,
} from "react-bootstrap";

function AgencyPolygonCreation() {
  const [govOffice, setGovOffice] = useState(undefined);
  const [thaiGov, setThaiGov] = useState(undefined);
  const [embassy, setEmbassy] = useState(undefined);
  const [policeDepartment, setPoliceDepartment] = useState(undefined);
  const [prohibitPolygon, setProhibitPolygon] = useState(undefined);
  const [thailandProvince, setThailandProvince] = useState(undefined);
  const [PDRArea, setPDRArea] = useState(undefined);
  const [Aerodrome, setAeroDrome] = useState(undefined);
  const [prohibitedAres, setProhibitedAres] = useState();
  const [restrictedAreas, setRestrictedAreas] = useState();
  const [dangerAreas, setDangerAres] = useState();
  const [bangkokPopulation, setBangkokPopulation] = useState();
  const [hospital, setHospital] = useState(undefined);
   const [populationShow, setPopulationShow] = useState(true);
   const legendPopulation = [
    { population: "น้อยกว่า 1000", color: 0.1 },
    { population: "1000-2499", color: 0.2 },
    { population: "2500-4999", color: 0.3 },
    { population: "5000-7499", color: 0.3 },
    { population: "7500-9999", color: 0.5 },
    { population: "10000-14999", color: 0.6 },
    { population: "15000-19999", color: 0.7 },
    { population: "20000-24999", color: 0.8 },
    { population: "มากกว่า 24999", color: 0.9 },
  ];

  const [sidebarMain, setSidebarMain] = useState(false);
  const [displayplans, setDisplayplans] = useState(1);

  ////Dataset from API
  const [GotArea, setGotArea] = useState(undefined);
  const [GotTimeID, setGotTimeID] = useState(undefined);
  const [allReservedArea, setAllReservedArea] = useState([]);

  ////Map
  const [position, setPosition] = useState([13.1008, 100.9305]);
  const [map, setMap] = useState(null);
  const mapRef = useRef();
  const onEachFeature = (feature, layer) => {
    if (feature.properties && feature.properties.name) {
      layer.bindPopup(feature.properties.name);
    }
  };
  const showMyLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          if (mapRef.current) {
            mapRef.current.flyTo(
              [position.coords.latitude, position.coords.longitude],
              17,
              {
                animate: true,
              }
            );
          }
        },
        (error) => {
          console.error("Error getting location:", error);
        }
      );
    }
    if (mapRef.current) {
      mapRef.current.flyTo([13.102617437258145, 100.88806223049966], 15, {
        animate: true,
      });
    }
  };
  const [showRemarks, setShowRemarks] = useState({
    ShowRemark1: false,
    ShowRemark2: false,
    ShowRemark3: false,
    ShowRemarkPlan: false,
    ShowRemarkNearPlan: false,
    DataFocus: "",
  });
  const [remarkData, setRemarkData] = useState({
    remarks: "",
    upperLimit: "",
    lowerLimit: "",
  });
  const RemarkDetails = ({ data, datatype }) => {
    console.log(data, datatype);
    if (
      data.remarks !== undefined &&
      data.lowerLimit !== undefined &&
      data.upperLimit !== undefined &&
      datatype === "remarkdata"
    ) {
      return (
        <div className="sidebox-remark" style={{ top: "300px" }}>
          <div className="remark-details">
            <div style={{ textAlign: "center" }}>
              <strong>{showRemarks.DataFocus}</strong>
              <i className="icon-edit" style={{ float: "right" }}>
                <IoCloseOutline
                  style={{ width: "30px", height: "30px" }}
                  onClick={() => {
                    setShowRemarks(false);
                    clearMap("MoveTo-center");
                  }}
                />
              </i>
            </div>
            <div>
              <strong>Type of restriction:</strong>{" "}
              {data.remarks["Type of restriction"]}
            </div>
            <div>
              <strong>Nature of hazard, activity:</strong>{" "}
              {data.remarks["Nature of hazard, activity"]}
            </div>
            <div>
              <strong>Time of activity:</strong>{" "}
              {data.remarks["Time of activity"]}
            </div>
            <div>
              <strong>Permission to entry:</strong>{" "}
              {data.remarks["Permission to entry"]}
            </div>
            <div>
              <strong>Inflight information:</strong>{" "}
              {data.remarks["Inflight information"]}
            </div>
            <div>
              <strong>Contact agency:</strong> {data.remarks["Contact agency"]}
            </div>
            <div>
              <strong>Tel :</strong> {data.remarks["Tel"]}
            </div>
            <div>
              <strong>UpperLimit :</strong> {data.upperLimit}
            </div>
            <div>
              <strong>Lower_limit :</strong> {data.lowerLimit}
            </div>
          </div>
        </div>
      );
    } else if (data !== undefined && datatype === "operator_data") {
      return (
        <div className="sidebox-remark" style={{ top: "300px" }}>
          <div className="remark-details" style={{ width: "100%" }}>
            <div style={{ textAlign: "center" }}>
              <strong>{showRemarks.DataFocus}</strong>
              <i className="icon-edit" style={{ float: "right" }}>
                <IoCloseOutline
                  style={{ width: "30px", height: "30px" }}
                  onClick={() => {
                    setShowRemarks(false);
                    clearMap("MoveTo-center");
                  }}
                />
              </i>
            </div>
            <div>
              <strong>วัตถุประสงค์ :</strong>{" "}
              {data.purpose === undefined ? null : data.purpose}
            </div>
            <div>
              <strong>ชื่อปฏิบัติการ :</strong>{" "}
              {data.name === undefined ? null : data.name}
            </div>
            <div>
              <strong>เวลาเริ่มต้น :</strong>{" "}
              {data.start_time === undefined ? null : data.start_time}
            </div>
            <div>
              <strong>เวลาสิ้นสุด :</strong>{" "}
              {data.end_time === undefined ? null : data.end_time}
            </div>
            <div>
              <strong>ความสูง :</strong>{" "}
              {data.altitude === undefined ? null : data.altitude}
            </div>
            <div>
              <strong>สถานะ :</strong>{" "}
              {data.operation_status_text === undefined
                ? null
                : data.operation_status_text}
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  };
  const [researchArea, setResearchArea] = useState([position[1], position[0]]);
  function DisplayPosition({ map }) {
    let [positions, setPositions] = useState(() => map.getCenter());
    const onClick = useCallback(() => {
      map.flyTo(position, 14);
    }, [map]);

    const onMove = useCallback(() => {
      setPositions(map.getCenter());
      setResearchArea([positions.lng, positions.lat]);
    }, [map]);

    useEffect(() => {
      map.on("move", onMove);
      return () => {
        map.off("move", onMove);
      };
    }, [map, onMove]);

    return (
      <text style={{ fontSize: "14px" }}>
        latitude: {positions.lat.toFixed(4)}, longitude:{" "}
        {positions.lng.toFixed(4)}
        <button
          style={{
            marginLeft: "5px",
            zIndex: 2,
            border: "none",
            opacity: "1px",
            backgroundColor: "rgb(255, 255, 255, 0.3)",
          }}
          onClick={() => {
            showMyLocation();
          }}
        >
          <GoLocation />
        </button>
      </text>
    );
  }
  const clearMap = (leafletId) => {
    map.eachLayer(function (layer) {
      if (layer.options && layer.options.id === leafletId) {
        map.removeLayer(layer);
      }
    });
  };
  function CheckdimensionData(multipolygon) {
    const size = turf.area(multipolygon);
    if (0 <= size && size <= 30000) {
      return 16;
    } else if (30000 < size && size <= 10000000) {
      return 14;
    } else if (10000000 < size && size <= 1000000000) {
      return 12;
    } else {
      return 10;
    }
  }
  function MoveToCenterPolygon(multipolygon, color) {
    clearMap("MoveTo-center");
    let centroid = turf.centroid(multipolygon);
    const viewsize = CheckdimensionData(multipolygon);
    ////(viewsize);
    L.geoJSON(multipolygon, {
      style: function (feature) {
        return { color: color, opacity: "1" };
      },
      id: "MoveTo-center",
    })
      .bindPopup(function (layer) {
        if (layer.feature.properties.name === undefined) {
          return "ไม่ทราบข้อมูล";
        } else {
          return layer.feature.properties.name;
        }
      })
      .addTo(map);
    map.setView(
      [centroid.geometry.coordinates[1], centroid.geometry.coordinates[0]],
      viewsize
    );
  }

  ///Editor Control func
  const deleteTimerRef = useRef(null);
  const [polygonArray, setPolygonArray] = useState([]);
  const [layerArray, setLayerArray] = useState([]);
  const [tempArrayID, setTempArrayID] = useState([]);
  const [isCreated, setIsCreated] = useState([]);
  const [fisrtlatlngOnCreation, setFisrtlatlngOnCreation] = useState([]);
  const [isEdited, setIsEdited] = useState([]);
  const [polygonToDelete, setPolygonToDelete] = useState([]);
  const [purposeValue, setPurposeValue] = useState("");
  const handleCreation = (e) => {
    const { layer } = e;
    setLayerArray((previous) => [...previous, layer]);

    let positions = [];
    console.log("eLayer : ", e.layer);

    if (layer instanceof L.Circle) {
      positions = calculateCircleMarkers(layer);
      setOperation_Area(e.layer.getLatLng().lat);
      setFisrtlatlngOnCreation([
        e.layer.getLatLng().lng,
        e.layer.getLatLng().lat,
      ]);
      ///func get area
    } else if (layer instanceof L.Polygon) {
      positions = convertPolygonToCoordinates(layer);
      setOperation_Area(e.layer._latlngs[0]);
      setFisrtlatlngOnCreation([
        e.layer._latlngs[0][0].lng,
        e.layer._latlngs[0][0].lat,
      ]);
      ///func get area
    }
    if (positions.length) {
      updateArrays(layer, positions);
    }
  };
  const calculateCircleMarkers = (layer) => {
    const { lat, lng } = layer.getLatLng();
    const circleRadius = layer._mRadius;
    const numPoints = 36;
    const markerPositions = [];
    for (let i = 0; i < numPoints; i++) {
      const angleRad = ((2 * Math.PI) / numPoints) * i;

      const deltaX = circleRadius * Math.cos(angleRad);
      const deltaY = circleRadius * Math.sin(angleRad);

      const newLng = lng + deltaX / (111320 * Math.cos(lat * (Math.PI / 180)));
      const newLat = lat + deltaY / 110574;

      markerPositions.push([newLng, newLat]);
    }

    markerPositions.push(markerPositions[0]);
    return markerPositions;
  };
  const convertPolygonToCoordinates = (polygon) => {
    const latLngs = polygon.getLatLngs()[0];
    const coordinates = latLngs.map(({ lng, lat }) => [lng, lat]);
    coordinates.push(coordinates[0]);
    return coordinates;
  };
  const updateArrays = (layer, positions) => {
    setTempArrayID((previous) => [...previous, layer._leaflet_id]);
    setPolygonArray((previous) => [...previous, positions]);
    setIsCreated((previous) => [...previous, positions]);
  };
  const handleEdit = (e) => {
    setIsEdited([]);
    const layers = e.layers._layers;
    if (tempArrayID[0] != undefined) {
    }
    setIsEdited(layers);
  };
  const handleDelete = (e) => {
    const layers = e.layers;
    const idArray = [];
    setFisrtlatlngOnCreation([]);
    setGotArea(undefined);
    clearTimeout(deleteTimerRef.current);
    deleteTimerRef.current = setTimeout(() => {
      layers.eachLayer((layer) => {
        if (layer instanceof L.Polygon) {
          idArray.push(layer._leaflet_id);
        }
        if (layer instanceof L.Circle) {
          idArray.push(layer._leaflet_id);
        }
      });
      setPolygonToDelete(idArray);
    }, 100);
    return () => clearTimeout(deleteTimerRef.current);
  };

  ///set up time
  const [chosenHeight, setChosenHeight] = useState(90);
  const [timedReservedArea, setTimedReservedArea] = useState([]);
  const [isTimeBeingSet, setIsTimeBeingSet] = useState(false);
  const presentTime = dayjs(new Date());
  const desiredLimit = dayjs(new Date() - 1 * 24 * 60 * 60 * 1000);
  const [dayTimeStart, setDayTimeStart] = useState(
    dayjs(new Date()).add(10, "minute")
  );
  const [dayTimeEnd, setDayTimeEnd] = useState(
    dayjs(new Date(timeStringToInt(dayTimeStart) + 10800000))
  );
  const shouldDisableStartDate = (date) => {
    return date <= desiredLimit;
  };
  const shouldDisableTime = (date) => {
    const currentDate = new Date();
    const selectedDate = new Date(date);

    currentDate.setMinutes(currentDate.getMinutes() + 10);
    const isInvalidTime =
      selectedDate.getHours() < 6 ||
      selectedDate.getHours() >= 17 ||
      selectedDate < currentDate;
    return isInvalidTime;
  };

  function timeStringToInt(time) {
    const date = new Date(time);
    return Math.round(date.getTime());
  }
  const handleChangeStart = (newValue) => {
    if (timeStringToInt(newValue) >= timeStringToInt(presentTime)) {
      setDayTimeStart(newValue);
      setDayTimeEnd(dayjs(new Date(timeStringToInt(newValue))).add(3, "hour"));
      layerArray.forEach((data) => {
        data.remove();
      });
      setLayerArray([]);
      setPolygonArray([]);
      const pickedIndex = allReservedArea
        .map((content, index) => {
          if (
            !(
              content.end_time <
                new Date(timeStringToInt(newValue)).getTime() ||
              content.start_time >
                new Date(timeStringToInt(dayTimeEnd)).getTime()
            )
          ) {
            return index;
          }
          return null; // Return null for elements that don't meet the condition
        })
        .filter((index) => index !== null); // Filter out null values

      const areaData = pickedIndex.map(
        (content) => allReservedArea[content].operation_area
      );
      // console.log(areaData);
      // console.log(quickSwapElement(areaData))
      setTimedReservedArea(areaData);
    }
  };
  const handleChangeEnd = (newValue) => {
    setDayTimeEnd(newValue);

    const pickedIndex = allReservedArea
      .map((content, index) => {
        if (
          !(
            content.end_time <
              new Date(timeStringToInt(dayTimeStart)).getTime() ||
            content.start_time > new Date(timeStringToInt(newValue)).getTime()
          )
        ) {
          return index;
        }
        return null; // Return null for elements that don't meet the condition
      })
      .filter((index) => index !== null);
    const areaData = pickedIndex.map(
      (content) => allReservedArea[content].operation_area
    );
    setTimedReservedArea(areaData);
    // if (timedReservedArea.length > 0) {
    //   setTimedReservedArea(areaData.flat(1));
    // }
    layerArray.forEach((data) => {
      data.remove();
    });
    setLayerArray([]);
    setPolygonArray([]);
  };

  /// Dataset wait for send to Backend
  const [timeID, setTimeID] = useState("");
  const [ninetyHeight, setNinetyHeight] = useState(false);
  const [operation_Area, setOperation_Area] = useState(null);
  function formattingDate(datetime) {
    const formattedDate = `${datetime.$y}-${
      datetime.$M < 10 ? "0" + (datetime.$M + 1) : datetime.$M + 1
    }-${datetime.$D < 10 ? "0" + datetime.$D : datetime.$D}T${
      datetime.$H < 10 ? "0" + datetime.$H : datetime.$H
    }:${datetime.$m < 10 ? "0" + datetime.$m : datetime.$m}:00+07:00`;
    console.log(formattedDate);
    return formattedDate;
  }
  ////func API
  function Get_Area_Operation(start_time, end_time, center_coord) {
    if (center_coord.length !== 0) {
      console.log("In fetch");
      try {
        Agencyservice.GetAreaData(
          start_time,
          // "2024-03-29T11:30:00+07:00",
          end_time,
          //"2024-03-29T14:30:00+07:00",
          center_coord
        )
          .then((res) => {
            setGotArea(undefined);
            console.log(res.data);
            const AllFeature = [];
            let responseData = res.data.area_data;
            responseData.map((feature) => {
              let stdCoordinates = [];
              feature.area_new_format.forEach(({ Lon, Lat }) => {
                stdCoordinates.push([Lon, Lat]);
              });
              let Feature = {
                type: "Feature",
                geometry: {
                  type: "MultiPolygon",
                  coordinates: [[stdCoordinates]],
                },
                properties: {
                  operation_code: feature.operation_code,
                  operation_id: feature.operation_id,
                  operation_status: feature.operation_status,
                  priority: feature.priority,
                },
              };
              AllFeature.push(Feature);
            });
            let GeoJson = {
              type: "FeatureCollection",
              features: AllFeature,
            };
            console.log(GeoJson);
            setGotArea(GeoJson);
            setGotTimeID(res.data.time_ID);
            Modal_MapDisplay();
            return res.data.time_ID;
          })
          .catch((err) => {
            alert("ไม่พบข้อมูล");
          });
      } catch (err) {
        alert("เกิดข้อผิดพลาด");
      }
    }
  }
  const handle_Check_Plan = async (
    time_id,
    purpose,
    operation_area,
    altitude,
    area_type
  ) => {
    console.log("timeID", "purpose", "operation_area", "altitude", "area_type");
    console.log(time_id, purpose, operation_area.length, altitude, area_type);
    setModalToggle({ ...modalToggle, modalwait: true });
    if (
      time_id !== undefined &&
      purpose !== "" &&
      operation_area.length !== 0
    ) {
      try {
        await Agencyservice.CheckOperation(
          time_id,
          purpose,
          operation_area,
          altitude,
          area_type
        )
          .then(async (res) => {
            console.log(res);
            if (res.status === 200) {
              console.log(res.data);
              console.log(res.data.area_data_in_prohibited_zone);
              await setModalMessage({
                ...modalMessage,
                showdata_check: {
                  ...modalMessage.showdata_check,
                  id: res.data.ID,
                  area: res.data.area_data_in_prohibited_zone,
                  status: res.data.status,
                },
              });
              await setTimeout(() => {
                modal_handleClose();
              }, 2000);
              await setTimeout(() => {
                setModalToggle({ ...modalToggle, showdata_check: true });
              }, 2100);
            } else {
              let errorMessage = "";
              switch (res.data.error_description) {
                case "Time_ID is not valid":
                case "The time  i d field is required.":
                  errorMessage = "กรุณาเลือกพื้นที่ใหม่ อีกครั้ง";
                  break;
                case "This area is already used":
                  errorMessage = "พื้นที่นี้ถูกเลือกไปแล้ว";
                  break;
                case "Operation time must not exceed 3 hours":
                  errorMessage = "กรุณาเลือกเวลาไม่เกิน 3 ชั่วโมง";
                  break;
                case "Operation start time is less than 10 minutes from now":
                  errorMessage = "กรุณาเลือกเวลาเริ่มต้นก่อนดำเนินแผน 10 นาที";
                  break;
                default:
                  errorMessage = "เกิดข้อผิดพลาด";
              }
              setModalMessage({
                ...modalMessage,
                modalErr: errorMessage,
              });
              setModalToggle({ ...modalToggle, modalErr: true });
            }
          })
          .catch((err) => {
            alert(err);
          });
      } catch (err) {
        alert("เกิดข้อผิดพลาด");
      }
    } else {
      console.log(purpose);
      if (purpose === "") {
        setModalMessage({ ...modalMessage, modalErr: "กรุณากรอกวัตถุประสงค์" });
      } else if (operation_area.length === 0) {
        setModalMessage({ ...modalMessage, modalErr: "กรุณาเลือกพื้นที่" });
      } else {
        setModalMessage({ ...modalMessage, modalErr: "เกิดข้อผิดพลาด" });
      }
      setModalToggle({ ...modalToggle, modalErr: true });
    }
  };
  function Confirm_Operation(data_id) {
    try {
      Agencyservice.ConfirmOperation(data_id)
        .then((res) => {
          console.log(res);
          if (res.data.status === "success") {
            setModalToggle({ ...modalToggle, modalSuccess: true });
            setTimeout(() => {
              modal_handleClose();
              //window.location.reload();
            }, 1000);
          } else if (res.data.status === "error") {
            if (res.data.error_description === "data_ID is not valid") {
              alert("กรุณาเลือกพื้นที่ และ กรอกข้อมูล ใหม่อีกครั้ง");
            }
          } else {
            alert("ไม่พบข้อมูล กรุณาลองใหม่อีกครั้ง");
          }
        })
        .catch((err) => {
          alert("ไม่พบข้อมูล กรุณาลองใหม่อีกครั้ง");
        });
    } catch (err) {
      console.log("err try catch");
      alert("เกิดข้อผิดพลาด");
    }
  }
  function Denied_Operation(data_id) {
    try {
      Agencyservice.CancelSaveOperation(data_id)
        .then((res) => {
          if (res.data.status === "success") {
            setModalToggle({ ...modalToggle, modalDenied: true });
            setTimeout(() => {
              modal_handleClose();
            }, 2000);
          } else if (res.data.status === "error") {
            if (res.data.error_description === "data_ID is not valid") {
              alert("กรุณาเลือกพื้นที่ และ กรอกข้อมูล ใหม่อีกครั้ง");
            }
          } else {
            alert("ไม่พบข้อมูล กรุณาลองใหม่อีกครั้ง");
          }
        })
        .catch((err) => {
          alert("ไม่พบข้อมูล กรุณาลองใหม่อีกครั้ง");
        });
    } catch (err) {
      alert("เกิดข้อผิดพลาด");
    }
  }

  const bangkokPopulationColorized = (feature) => {
    const population = feature.properties.DN;
    return {
      fillColor: "red",
      color: "transparent",
      fillOpacity:
        population < 1000
          ? 0.1
          : population >= 1000 && population < 2500
          ? 0.2
          : population >= 2500 && population < 5000
          ? 0.3
          : population >= 5000 && population < 7500
          ? 0.4
          : population >= 7500 && population < 10000
          ? 0.5
          : population >= 10000 && population < 15000
          ? 0.6
          : population >= 15000 && population < 20000
          ? 0.7
          : population >= 20000 && population < 25000
          ? 0.8
          : 0.9,
    };
  };

  ///Fetch Data API
  const [GotPlan, setGotPlan] = useState(undefined);
  const getPolygonPosition = () => {
    try {
      let operationlist = Agencyservice.Opearationdata();
      if (operationlist !== undefined) {
        if (operationlist != null) {
          operationlist.then((response) => {

            const responseData = response.data;
            const AllFeature = [];

            responseData.map((feature) => {
              let stdCoordinates = [];
              feature.operation_area.Volume3D.outline_polygon.vertices.forEach(
                ({ Lon, Lat }) => {
                  stdCoordinates.push([Lon, Lat]);
                }
              );
              let Feature = {
                type: "Feature",
                geometry: {
                  type: "Polygon",
                  coordinates: [stdCoordinates],
                },
                properties: {
                  name: feature.id,
                  aircraft_type: feature.aircraft_type,
                  aircraft_count: feature.aircraft_count,
                  aircraft_count_pending: feature.aircraft_count_pending,
                  current_state: feature.current_state,
                  start_time: feature.start_time,
                  end_time: feature.end_time,
                  operation_id: feature.operation_id,
                  operation_status: feature.operation_status,
                  operation_type: feature.operation_type,
                  operation_status_text: feature.operation_status_text,
                  altitude: feature.operation_area.Volume3D.altitude,
                  purpose: feature.purpose,
                },
              };

              AllFeature.push(Feature);
            });
            let GeoJson = {
              type: "FeatureCollection",
              features: AllFeature.reverse(),
            };
            console.log(GeoJson);
            setGotPlan(GeoJson);
          });
        }
      } else {
        alert("เกิดข้อผิดพลาดในการดึงข้อมูล");
      }
    } catch (err) {
      console.error("Error fetching JSON data:", err);
    }
  };

  ///Modal
  const [modalToggle, setModalToggle] = useState({
    showdata_check: false,
    modalSuccess: false,
    modalDenied: false,
    modalErr: false,
    modalwait: false,
  });
  const modal_handleClose = () => {
    // Close all modals
    setModalToggle({
      showdata_check: false,
      modalSuccess: false,
      modalDenied: false,
      modalErr: false,
      modalwait: false,
    });
  };
  const [modalMessage, setModalMessage] = useState({
    showdata_check: { id: null, area: [], status: null },
    modalSuccess: "",
    modalDenied: "",
    modalErr: "",
  });
  const [Modal_MapData, setModal_Mapdata] = useState({
    center: [13.11, 100.92],
    geojson: [],
  });
  function Modal_MapDisplay() {
    console.log(polygonArray);
    if (polygonArray.length !== 0) {
      let Feature = {
        type: "Feature",
        geometry: {
          type: "MultiPolygon",
          coordinates: [polygonArray],
        },
        properties: {
          your_area: "พื้นที่ของคุณ",
        },
      };
      let GeoJson = {
        type: "FeatureCollection",
        features: Feature,
      };
      let centroid = turf.centroid(GeoJson.features);
      console.log(centroid);
      setModal_Mapdata({
        ...Modal_MapData,
        center: [
          centroid.geometry.coordinates[1],
          centroid.geometry.coordinates[0],
        ],
        geojson: Feature,
      });
    }
  }

  useEffect(() => {
    setSidebarMain(true);
    async function fetchData() {
      try {
        const [
          responsePDRArea,
          responseAeroDrome,
          responseHospital,
          responseGovOffice,
          responseEmbassy,
          responsePoliceDepartment,
          responseThaiGov,
          allGeoData,
          responseBangkokPopulation,
        ] = await Promise.all([
          axios.get("../../PDR-AREA.geojson"),
          axios.get("../../Aerodrome.geojson"),
          axios.get("../../hospitalLocation.geojson"),
          axios.get("../../GovOfficetoutput.geojson"),
          axios.get("../../Embassyoutput.geojson"),
          axios.get("../../PoliceDepartmentoutput.geojson"),
          axios.get("../../ThaiGovoutput.geojson"),
          AuthServiceV2.AllGeoFenceData(),
          axios.get("../../BKK_District.geojson"),
        ]);

        const { prohibited_areas, danger_areas, restricted_areas, aerodrome } =
          allGeoData.data;

        const PDRDataset = {
          type: "FeatureCollection",
          features: [
            ...prohibited_areas.features,
            ...danger_areas.features,
            ...restricted_areas.features,
          ],
        };

        setProhibitedAres(prohibited_areas.features);
        setRestrictedAreas(restricted_areas.features);
        setDangerAres(danger_areas.features);
        setPDRArea(PDRDataset);
        setAeroDrome(aerodrome.features);
        setHospital(responseHospital.data);
        setGovOffice(responseGovOffice.data);
        setThaiGov(responseThaiGov.data);
        setPoliceDepartment(responsePoliceDepartment.data);
        setEmbassy(responseEmbassy.data);
        setBangkokPopulation(responseBangkokPopulation.data);
        const tempAllData = [
          ...aerodrome.features.map(({ geometry, properties }) => ({
            area: geometry.coordinates[0][0],
            name: properties.province,
            referrence: properties.asdf,
          })),
          ...danger_areas.features.map(({ geometry, properties }) => ({
            area: geometry.coordinates[0][0],
            name: properties.name,
            referrence: properties.remarks.Tel,
          })),
          ...prohibited_areas.features.map(({ geometry, properties }) => ({
            area: geometry.coordinates[0][0],
            name: properties.name,
            referrence: properties.remarks.Tel,
          })),
          ...restricted_areas.features.map(({ geometry, properties }) => ({
            area: geometry.coordinates[0][0],
            name: properties.name,
            referrence: properties.remarks.Tel,
          })),
          ...responseHospital.data.features.map(({ geometry, properties }) => ({
            area: geometry.coordinates[0],
            name: properties.Agency,
            referrence: properties.Department,
          })),
          ...responseGovOffice.data.features.map(
            ({ geometry, properties }) => ({
              area: geometry.coordinates[0],
              name: properties.name,
              referrence: properties.tel,
            })
          ),
          ...responseEmbassy.data.features.map(({ geometry, properties }) => ({
            area: geometry.coordinates[0],
            name: properties.name_t,
            referrence: properties.tel,
          })),
          ...responsePoliceDepartment.data.features.map(
            ({ geometry, properties }) => ({
              area: geometry.coordinates[0],
              name: properties.name,
              referrence: properties.tel,
            })
          ),
          ...responseThaiGov.data.features.map(({ geometry, properties }) => ({
            area: geometry.coordinates[0],
            name: properties.name,
            referrence: properties.tel,
          })),
        ];
        setProhibitPolygon(tempAllData);
      } catch (error) {
        console.error("Error fetching JSON data:", error);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    const tempPolygonArrayEdited = [...polygonArray];
    Object.entries(isEdited).forEach(([key, value]) => {
      const index = tempArrayID.findIndex((id) => id === parseInt(key));
      if (value instanceof L.Polygon) {
        tempPolygonArrayEdited[index] = convertPolygonToCoordinates(value);
      } else if (value instanceof L.Circle) {
        tempPolygonArrayEdited[index] = calculateCircleMarkers(value);
      }
    });
    setPolygonArray(tempPolygonArrayEdited);
  }, [isEdited]);
  useEffect(() => {
    const indicesToDelete = [];

    polygonToDelete.forEach((id) => {
      const indexToDelete = tempArrayID.findIndex((object) => object === id);
      indicesToDelete.push(indexToDelete);
    });

    const updatedPolygonArray = polygonArray.filter(
      (_, index) => !indicesToDelete.includes(index)
    );
    setPolygonArray(updatedPolygonArray);

    const updatedTempArrayID = tempArrayID.filter(
      (_, index) => !indicesToDelete.includes(index)
    );
    setTempArrayID(updatedTempArrayID);

    const updatedLayerArray = layerArray.filter(
      (_, index) => !indicesToDelete.includes(index)
    );
    setLayerArray(updatedLayerArray);
  }, [polygonToDelete]);

  useEffect(() => {
    Get_Area_Operation(
      formattingDate(dayTimeStart),
      formattingDate(dayTimeEnd),
      fisrtlatlngOnCreation
    );
  }, [polygonArray]);
  useEffect(() => {
    getPolygonPosition();
  }, [modalToggle.modalSuccess]);
  ///scroll Effect
  const [scrollPosition, setScrollPosition] = useState(window.scrollY);
  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  function Data_Name(prop) {
    const isoDateTime = prop.start_time;
    const date = new Date(isoDateTime);
    const purpose = prop.purpose;
    const formattedDate = `${("0" + date.getDate()).slice(-2)}/${(
      "0" +
      (date.getMonth() + 1)
    ).slice(-2)}/${date.getFullYear()}`;
    const formattedTime = `${("0" + date.getHours()).slice(-2)}:${(
      "0" + date.getMinutes()
    ).slice(-2)}`;
    return (
      <div className="modal-body-grid3">
        <div className="grid-item">D: {formattedDate}</div>
        <div className="grid-item">T: {formattedTime}</div>
        <div className="grid-item">{purpose}</div>
      </div>
    );
  }
  return (
    <>
      <div
        style={{
          height: "93.25vh",
          width: "100%",
          display: "flex",
        }}
      >
        {/* MapContainer */}
        <MapContainer
          id="map"
          center={position}
          zoom={14}
          keyboard={true}
          style={{
            display: "relative",
            height: "100vh",
            width: "100%",
            zIndex: 1,
          }}
          ref={setMap}
        >
          {thailandProvince && (
            <GeoJSON
              data={thailandProvince}
              style={{
                color: null,
                fillColor: "white",
                fillOpacity: 0,
              }}
              // onEachFeature={onEachFeature}
            />
          )}

          <LayersControl position="bottomright">
            <LayersControl.BaseLayer name="Google Map">
              <TileLayer
                style={{ zIndex: 2 }}
                url="http://www.google.cn/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}"
              />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer checked name="OpenStreet Map">
              <TileLayer
                style={{ zIndex: 2 }}
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer name="OpenToPo Map">
              <TileLayer
                style={{ zIndex: 2 }}
                url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
              />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer name="ThunderForest Map">
              <TileLayer
                style={{ zIndex: 2 }}
                url="https://tile.thunderforest.com/landscape/{z}/{x}/{y}.png
"
              />
            </LayersControl.BaseLayer>
            <LayersControl.Overlay checked name="Aerodome area">
              {Aerodrome && (
                <GeoJSON
                  data={Aerodrome}
                  style={{
                    color: "orange",
                    fillColor: "orange",
                    fillOpacity: 0.5,
                  }}
                  onEachFeature={onEachFeature}
                />
              )}
            </LayersControl.Overlay>
            <LayersControl.Overlay checked name="Flight prohibitation area">
              {PDRArea && (
                <GeoJSON
                  data={PDRArea}
                  style={{
                    color: "red",
                    fillColor: "red",
                    fillOpacity: 0.5,
                  }}
                  onEachFeature={onEachFeature}
                />
              )}
            </LayersControl.Overlay>
            <LayersControl.Overlay checked name="Hospital area">
          {hospital && (
            <GeoJSON
              data={hospital}
              style={{
                color: "purple",
                fillColor: "purple",
                fillOpacity: 0.5,
              }}
              onEachFeature={onEachFeature}
            />
          )}
        </LayersControl.Overlay>
            <LayersControl.Overlay checked name="Goverment Office area (blue)">
              {govOffice && (
                <GeoJSON
                  data={govOffice}
                  style={{
                    color: "blue",
                    fillColor: "blue",
                    fillOpacity: 0.5,
                  }}
                  onEachFeature={onEachFeature}
                />
              )}
            </LayersControl.Overlay>
            <LayersControl.Overlay checked name="Embassy area (yellow)">
              {embassy && (
                <GeoJSON
                  data={embassy}
                  style={{
                    color: "yellow",
                    fillColor: "yellow",
                    fillOpacity: 0.5,
                  }}
                  onEachFeature={onEachFeature}
                />
              )}
            </LayersControl.Overlay>
            <LayersControl.Overlay
              checked
              name="Police department area (green)"
            >
              {policeDepartment && (
                <GeoJSON
                  data={policeDepartment}
                  style={{
                    color: "green",
                    fillColor: "green",
                    fillOpacity: 0.5,
                  }}
                  onEachFeature={onEachFeature}
                />
              )}
            </LayersControl.Overlay>
            <LayersControl.Overlay checked name="Thai Goverment area (red)">
              {thaiGov && (
                <GeoJSON
                  data={thaiGov}
                  style={{
                    color: "red",
                    fillColor: "red",
                    fillOpacity: 1,
                  }}
                  onEachFeature={onEachFeature}
                />
              )}
            </LayersControl.Overlay>
            {bangkokPopulation && populationShow === true ? (
                          <GeoJSON
                            data={bangkokPopulation}
                            style={bangkokPopulationColorized}
                            onEachFeature={onEachFeature}
                          />
                        ) : null}
          </LayersControl>

          <FeatureGroup style={{ marginTop: "30px" }}>
            {/* displayPosition  */}
            <Control position="topright">
              <div
                className="refreshButton"
                style={{ top: "0px", right: "10px", position: "none" }}
              >
                {map ? <DisplayPosition map={map} /> : null}
              </div>
            </Control>
            <Control prepend position="bottomleft">
            <div
              style={{
                width: "250px",
                backgroundColor: "white",
                borderWidth: "1px",
                borderColor: "grey",
                color: "black",
              }}
            >
              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <label style={{ fontSize: "16px", margin: "0px auto" }}>
                  <input
                    style={{
                      marginRight: "5px",
                      height: "14px",
                      width: "15px",
                    }}
                    type="checkbox"
                    checked={populationShow}
                    onChange={() => {
                      if (populationShow === false) {
                        setPopulationShow(true);
                      } else {
                        setPopulationShow(false);
                      }
                    }}
                  />
                  ข้อมูลความหนาแน่นประชากร
                </label>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingTop: "10px",
                }}
              >
                สีของความหนาแน่นประชากร
              </div>
              <div
                style={{
                  paddingTop: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingBottom: "10px",
                }}
              >
                <table>
                  <thead>
                    <tr>
                      <th style={{ padding: "0px 10px" }}>สี</th>
                      <th style={{ padding: "0px 10px" }}>จำนวนประชากร</th>
                    </tr>
                  </thead>
                  <tbody>
                    {legendPopulation.map((item, index) => (
                      <tr key={index}>
                        <td
                          style={{
                            color: "red",
                            opacity: item.color,
                            padding: "0px 10px",
                          }}
                        >
                          <FaCircle />
                        </td>
                        <td style={{ padding: "0px 10px" }}>
                          {item.population}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </Control>
            <EditControl
              position="topright"
              onCreated={handleCreation}
              onEdited={handleEdit}
              onDeleted={handleDelete}
              draw={{
                polyline: false,
                polygon:
                  polygonArray.length === 0
                    ? {
                        allowIntersection: false,
                        showArea: true,
                        showLength: true,
                        metric: ["km", "m"],
                        shapeOptions: {
                          color: "green",
                          fillColor: "lightgreen",
                          fillOpacity: 0.6,
                        },
                      }
                    : false,
                rectangle: false,
                circle:
                  polygonArray.length === 0
                    ? {
                        shapeOptions: {
                          color: "green",
                          fillColor: "lightgreen",
                          fillOpacity: 0.6,
                        },
                      }
                    : false,
                marker: false,
                circlemarker: false,
              }}
              edit={{
                delete: true,
                edit: true,
              }}
            />
          </FeatureGroup>

          {GotArea !== undefined && (
            <GeoJSON
              data={GotArea}
              style={{
                color: "blue",
                fillColor: "blue",
                fillOpacity: 0.5,
              }}
              onEachFeature={onEachFeature}
            />
          )}
        </MapContainer>

        {/* scrollTo */}
        {/* {scrollPosition === 0 ? (
        <>
          <OverlayTrigger
            key={"top"}
            placement={"top"}
            overlay={<Tooltip id={`tooltip-${"top"}`}>to bottom</Tooltip>}
          >
            <div
              className="toNav-btn icon-pointer"
              style={{ bottom: "0px", borderRadius: "10px 10px 0px 0px" }}
              onClick={() => {
                window.scrollTo(0, 100);
              }}
            >
              <MdOutlineKeyboardDoubleArrowUp
                style={{ transform: "scaleY(-1)" }}
              />
            </div>
          </OverlayTrigger>
        </>
      ) : (
        <>
          <OverlayTrigger
            key={"bottom"}
            placement={"bottom"}
            overlay={<Tooltip id={`tooltip-${"bottom"}`}>to above</Tooltip>}
          >
            <div
              className="toNav-btn icon-pointer"
              style={{ top: "84.5px", borderRadius: "0px 0px 10px 10px" }}
              onClick={() => {
                window.scrollTo(0, 0);
              }}
            >
              <MdOutlineKeyboardDoubleArrowUp />
            </div>
          </OverlayTrigger>
        </>
      )} */}
        {/* Sidebar */}
        {sidebarMain === true ? (
          <>
            <div
              className="sidebar-main"
              style={{
                position: "relative",
                top: "0px",
                height: "auto",
                width: "30%",
                animation: "none",
              }}
            >
              <Offcanvas.Header
                className="sidebar-header"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Offcanvas.Title>
                  <h3 style={{ marginTop: "15px" }}> สร้างแผนการบิน</h3>
                </Offcanvas.Title>
              </Offcanvas.Header>

              <Tabs
                fill
                id="controlled-tabs"
                defaultActiveKey={displayplans}
                style={{
                  marginTop: "20px",
                  color: "#0077B6",
                  fontSize: "15px",
                }}
              >
                {/* <Tab
                eventKey="1"
                className="nav-link-test"
                title={
                  <span
                    className="tabplan"
                    style={{
                      color: "#0077B6",
                      fontWeight: "500",
                    }}
                  >
                    แผนการบินของคุณ
                  </span>
                }
              >
                <Offcanvas.Body>
                  <div className="sidebar-wrapper">
                    <div className="sidebar-card">
                      <div
                        className="sidebar-card-body"
                        style={{ maxHeight: "300px" }}
                      >
                        <div
                          className="sidebar-card-title"
                          style={{ marginBottom: "15px", color: "#0077B6" }}
                        >
                          <h5 style={{ fontSize: "18px" }}>
                            แผนการบินกำลังดำเนินการ{" "}
                          </h5>
                        </div>
                        {GotPlan !== undefined ? (
                          GotPlan.features.map((feature) => {
                            if(feature.properties.operation_status_text ==="อนุมัติ"){
                              return (
                                <p
                                  tabIndex={0}
                                  className="datafeatures"
                                  onClick={() => {
                                      MoveToCenterPolygon(feature,"black");
                                      setShowRemarks(() => ({
                                        ShowRemarkPlan: true,
                                        DataFocus: feature.properties.name,
                                      }));
                                      setRemarkData(feature.properties);
                                    }}
                                >
                                  {feature.properties.name !== undefined ? (
                                    <p>{Data_Name(feature.properties)}</p>
                                  ) : (
                                   null
                                  )}
                                </p>
                              );
                            }
                          })
                        ) : (
                          <p style={{ color: "red", textAlign: "center" }}>
                            {" "}
                            *** ไม่พบข้อมูลแผนการบินที่กำลังทำการ ***
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="sidebar-wrapper">
                    <div className="sidebar-card">
                      <div
                        className="sidebar-card-body"
                        style={{ maxHeight: "340px" }}
                      >
                        <div
                          className="sidebar-card-title"
                          style={{ marginBottom: "15px", color: "#0077B6" }}
                        >
                          <h5 style={{ fontSize: "18px" }}>
                            แผนการบินเสร็จสิ้นภารกิจ{" "}
                          </h5>
                        </div>
                        {GotPlan !== undefined ? (
                          GotPlan.features.map((feature) => {
                            if(feature.properties.operation_status_text ==="เสร็จภารกิจ"){
                              return (
                                <p
                                  tabIndex={0}
                                  className="datafeatures"
                                  onClick={() => {
                                      MoveToCenterPolygon(feature,"green");
                                      setShowRemarks(() => ({
                                        ShowRemarkPlan: true,
                                        DataFocus: feature.properties.name,
                                      }));
                                      setRemarkData(feature.properties);
                                    }}
                                >
                                  {feature.properties.name !== undefined ? (
                                    <p>{Data_Name(feature.properties)}</p>
                                  ) : (
                                   null
                                  )}
                                </p>
                              );
                            }
                          })
                        ) : (
                          <p style={{ color: "red", textAlign: "center" }}>
                            {" "}
                            *** ไม่พบข้อมูลแผนการบินที่กำลังทำการ ***
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                  {showRemarks.ShowRemarkPlan === true ? (
                      <RemarkDetails
                        data={remarkData}
                        datatype={"operator_data"}
                      />
                    ) : null}
                </Offcanvas.Body>
              </Tab> */}
                <Tab eventKey="1">
                  <Offcanvas.Body>
                    <div
                      className="sidebar-wrapper"
                      style={{ overflowX: "hidden" }}
                    >
                      <div
                        className="sidebar-card"
                        style={{
                          boxShadow: "0px 0px 0px 0px",
                          backgroundColor: "white",
                          padding: "0px 0px",
                          marginLeft: "auto",
                          marginRight: "auto",
                          width: "100%",
                        }}
                      >
                        <div
                          className="selection-Date"
                          style={{ display: "inline", textAlign: "start" }}
                        >
                          <label>วัตถุประสงค์</label>
                          <div className="date-field-agency">
                            <input
                            style={{borderRadius:"100px", borderWidth:"1px", width:"100%"}}
                              value={purposeValue}
                              onChange={(e) => {
                                setPurposeValue(e.target.value);
                              }}
                            ></input>
                          </div>
                          <label>เวลาเริ่มต้น</label>
                          <div className="date-field-agency">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DateTimePicker
                                 slotProps={{
                                  textField: {
                                    sx: {
                                      "& .MuiInputBase-root": {
                                        height: "40px",
                                        width: "100%",
                                        fontSize: "15px",
                                        borderWidth: "0px",
                                        borderRadius: "100px",
                                        backgroundColor: "white",
                                      },
                                    },
                                    fullWidth: true,
                                  },
                                }}
                                ampm={false}
                                closeOnSelect={true}
                                shouldDisableDate={shouldDisableStartDate}
                                shouldDisableTime={shouldDisableTime}
                                value={dayTimeStart}
                                onClose={() => {
                                  setTimeout(() => {
                                    setIsTimeBeingSet(!isTimeBeingSet);
                                  }, 500);
                                }}
                                onChange={handleChangeStart}
                              />
                            </LocalizationProvider>
                          </div>
                          <label>เวลาสิ้นสุด *เลือกไม่เกิน 3 ชั่วโมง</label>
                          <div className="date-field-agency">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DateTimePicker
                              slotProps={{
                                textField: {
                                  sx: {
                                    "& .MuiInputBase-root": {
                                      height: "40px",
                                      width: "100%",
                                      fontSize: "15px",
                                      borderWidth: "0px",
                                      borderRadius: "100px",
                                      backgroundColor: "white",
                                    },
                                  },
                                  fullWidth: true,
                                },
                              }}
                                ampm={false}
                                closeOnSelect={true}
                                shouldDisableTime={(date) => {
                                  return (
                                    date < dayTimeStart ||
                                    date > dayTimeStart.add(3, "hour") ||
                                    new Date(date).getHours() >= 17
                                  );
                                }}
                                shouldDisableDate={(date) => {
                                  return (
                                    date < dayTimeStart.add(-24, "hour") ||
                                    date > dayTimeStart.add(3, "hour")
                                  );
                                }}
                                value={dayTimeEnd}
                                onClose={() => {
                                  setTimeout(() => {
                                    setIsTimeBeingSet(!isTimeBeingSet);
                                  }, 500);
                                }}
                                onChange={handleChangeEnd}
                              />
                            </LocalizationProvider>
                          </div>
                          <label style={{ color: "red" }}>
                            เลือกพื้นที่* (3 ตำแหน่งขึ้นไป)
                          </label>
                          <div className="date-field-agency">
                            <input
                             style={{borderRadius:"100px", borderWidth:"1px", width:"100%"}}
                              className="other-field"
                              value={polygonArray}
                              readOnly
                            />
                          </div>

                          <label>
                            <input
                              type="checkbox"
                              onChange={() => {
                                setNinetyHeight(!ninetyHeight);
                                setChosenHeight(90);
                              }}
                            />{" "}
                            ความสูงเกิน 90 เมตร
                          </label>
                          {ninetyHeight === true ? (
                            <>
                              <div className="date-field-agency">
                                <input
                                  className="other-field"
                                  value={chosenHeight}
                                  onChange={(e) => {
                                    if (!isNaN(+e.target.value)) {
                                      setChosenHeight(e.target.value);
                                    }
                                  }}
                                />
                              </div>
                            </>
                          ) : null}

                          <div
                            className="date-field-agency"
                            style={{ marginTop: "15px", width:"100%", height:"70px", justifyContent:"center",
                              display:"flex", alignItems:"center"
                             }}
                          >
                            <button
                              className="custom-btn btnSave "
                              
                              style={{
                                width: "300px",
                                height: "50px",
                                fontSize: "20px",
                               
                           
                              }}
                              onClick={() =>
                                handle_Check_Plan(
                                  GotTimeID,
                                  purposeValue,
                                  polygonArray,
                                  parseInt(chosenHeight),
                                  2
                                )
                              }
                            >
                              ประเมินแผน
                            </button>
                          </div>
                          <div
                            className="date-field-agency"
                            style={{ marginTop: "15px" }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  </Offcanvas.Body>
                  <OverlayTrigger
                    key={"right"}
                    placement={"right"}
                    overlay={<Tooltip id={`tooltip-${"right"}`}>Close</Tooltip>}
                  >
                    <div
                      className="toNavSide-btn icon-pointer"
                      style={{
                        top: "50%",
                        borderRadius: "0px 10px 10px 0px",
                        animation: "none",
                        width: "12.5px",
                      }}
                      onClick={() => {
                        setSidebarMain(!sidebarMain);
                      }}
                    >
                      <MdDoubleArrow />
                    </div>
                  </OverlayTrigger>
                  {/* Section 2 */}
                </Tab>
                {/* <Tab
                eventKey="3"
                title={
                  <span
                    className="tabplan"
                    style={{
                      color: "#0077B6",
                      fontWeight: "500",
                    }}
                  >
                    อื่นๆ
                  </span>
                }
              >
                <Offcanvas.Body>
                  <div className="sidebar-wrapper">
                    <div className="sidebar-card">
                      <div className="sidebar-card-title">
                        <h6>พื้นที่อื่นๆ</h6>
                      </div>
                      <div
                        className="sidebar-card-body"
                        style={{ maxHeight: "220px" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyItems: "space-between",
                            padding: "10px",
                          }}
                        >
                          <div>
                            <Button variant="danger">
                              ตรวจสอบพื้นที่ห้ามบินทั้งหมด
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Offcanvas.Body>
              </Tab> */}
              </Tabs>
            </div>
          </>
        ) : (
          <div
            className="sidebar-main"
            style={{
              position: "relative",
              top: "0px",
              height: "auto",
              width: "1%",
              animation: "none",
            }}
          >
            <OverlayTrigger
              key={"right"}
              placement={"left"}
              overlay={<Tooltip id={`tooltip-${"left"}`}>Open</Tooltip>}
            >
              <div
                className="toNavSide-btn icon-pointer"
                style={{
                  top: "50%",
                  borderRadius: "10px 0px 0px 10px",
                  right: "0px",
                  animation: "none",
                }}
                onClick={() => {
                  setSidebarMain(!sidebarMain);
                }}
              >
                <MdDoubleArrow style={{ transform: "scaleX(-1)" }} />
              </div>
            </OverlayTrigger>
          </div>
        )}
      </div>

      {/* Modal Waiting */}
      <Modal
        size="sm"
        show={modalToggle.modalwait}
        onHide={modal_handleClose}
        centered
      >
        <Modal.Header>
          <Modal.Body>
            <div class="container-modal-loding">
              <div class="flex">
                <div class="loader" />
              </div>
              <div class="load-text">กำลังประเมินแผน...</div>
            </div>
          </Modal.Body>
        </Modal.Header>
      </Modal>
      {/* action success */}
      <Modal
        size="sm"
        show={modalToggle.modalSuccess}
        onHide={modal_handleClose}
        centered
      >
        <Modal.Body style={{ height: "250px" }}>
          <div class="success-checkmark">
            <div class="check-icon">
              <span class="icon-line line-tip" />
              <span class="icon-line line-long" />
              <div class="icon-circle"></div>
              <div class="icon-fix"></div>
            </div>
          </div>

          <h3 class="text-center text-success">สำเร็จ!</h3>
        </Modal.Body>
      </Modal>
      {/* action denied */}
      <Modal
        size="sm"
        show={modalToggle.modalDenied}
        onHide={modal_handleClose}
        centered
      >
        <Modal.Body style={{ height: "250px" }}>
          <div class="wrap">
            <svg
              width="100"
              height="100"
              viewBox="0 0 447 447"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="cancel-mark">
                <rect width="447" height="447" fill="white" />
                <circle
                  id="Circle"
                  cx="223.5"
                  cy="223.5"
                  r="210.5"
                  stroke="#9F2B2B"
                  stroke-width="26"
                />
                <g id="X-mark">
                  <line
                    id="Line"
                    x1="119.385"
                    y1="115.92"
                    x2="330.92"
                    y2="325.615"
                    stroke="#9F2B2B"
                    stroke-width="26"
                    stroke-linecap="round"
                  />
                  <line
                    id="Line"
                    x1="331.809"
                    y1="119.384"
                    x2="119.384"
                    y2="328.178"
                    stroke="#9F2B2B"
                    stroke-width="26"
                    stroke-linecap="round"
                  />
                </g>
              </g>
            </svg>
          </div>
          <h3 class="text-center text-danger">ยกเลิก!</h3>
        </Modal.Body>
      </Modal>
      {/* action showdata_check */}
      <Modal
        show={modalToggle.showdata_check}
        onHide={modal_handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {modalMessage.showdata_check.status === null ? (
              <h6>OPEN</h6>
            ) : (
              <h6 style={{ color: "#FFA500", fontSize: "24px" }}>
                {modalMessage.showdata_check.status.split(" || ")[1]}
              </h6>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal-body-grid2">
            <div className="grid-item">
              <h5>วัตถุประสงค์</h5>
              <h6>
                {purposeValue !== "" ? <h6>{purposeValue}</h6> : <h6>-</h6>}
              </h6>
            </div>
            <div className="grid-item">
              <h5>ความสูง</h5>
              <h6>{chosenHeight}</h6>
            </div>
            <div className="grid-item">
              <h5>วัน เวลาเริ่มต้น</h5>
              <h6>
                {("0" + dayTimeStart["$D"]).slice(-2)}/
                {("0" + (dayTimeStart["$M"] + 1)).slice(-2)}/
                {dayTimeStart["$y"]} - {("0" + dayTimeStart["$H"]).slice(-2)} :{" "}
                {("0" + dayTimeStart["$m"]).slice(-2)} : 00
              </h6>
            </div>
            <div className="grid-item">
              <h5>วัน เวลาสิ้นสุด</h5>
              <h6>
                {("0" + dayTimeEnd["$D"]).slice(-2)}/
                {("0" + (dayTimeEnd["$M"] + 1)).slice(-2)}/{dayTimeEnd["$y"]} -{" "}
                {("0" + dayTimeEnd["$H"]).slice(-2)} :{" "}
                {("0" + dayTimeEnd["$m"]).slice(-2)} : 00
              </h6>
            </div>
          </div>

          <div className="modal-horizontal-line" />
          <h5>พื้นที่ที่เลือก </h5>
          <div id="map-container" style={{ width: "100%", height: "150px" }}>
            {/* modalmap */}
            <MapContainer
              center={Modal_MapData.center}
              zoom={14}
              style={{ width: "100%", height: "100%" }}
            >
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
              {Modal_MapData.geojson && (
                <GeoJSON
                  data={Modal_MapData.geojson}
                  style={{
                    color: "green",
                    fillColor: "green",
                    fillOpacity: 0.5,
                  }}
                  onEachFeature={onEachFeature}
                />
              )}
            </MapContainer>
          </div>
          {modalMessage.showdata_check.area.length !== 0 ? (
            <>
              <h5 style={{ marginTop: "10px" }}>พื้นที่หวงห้าม</h5>
              <div className="modal-body-grid">
                {modalMessage.showdata_check.area.map((feature) => (
                  <div className="grid-item">
                    {" "}
                    <h6>- {feature}</h6>
                  </div>
                ))}
              </div>
            </>
          ) : null}
        </Modal.Body>
        <Modal.Footer>
          <div className="modal-body-grid2">
            <button
              style={{ width: "150px" }}
              className="custom-btn btnCancel grid-item"
              onClick={() => {
                Denied_Operation(modalMessage.showdata_check.id);
              }}
            >
              ยกเลิก
            </button>
            <button
              style={{ width: "150px" }}
              className="custom-btn btnSave grid-item"
              onClick={() => {
                Confirm_Operation(modalMessage.showdata_check.id);
              }}
            >
              ยืนยัน
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* action err */}
      <Modal show={modalToggle.modalErr} onHide={modal_handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h4>ตรวจสอบข้อมูล</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="font-cen">{modalMessage.modalErr}</Modal.Body>
        <Modal.Footer>
          <button className="custom-btn btnSave" onClick={modal_handleClose}>
            ยืนยัน
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AgencyPolygonCreation;
